import { MailboxDelivery } from "/react4xp/parts/delivery/mailbox-delivery";

export default (props) => <MailboxDelivery {...props} />;
